
import validator from 'validator';
import { toast } from 'react-toastify';
export const validate = (fieldName, fieldValue, validatType, canNull, elementId) => {
    let isvalid = true;
    if (!canNull) {
        if (fieldValue == null || fieldValue.trim() == '') {
            toast.error(`${fieldName} cannot be Blank.`);
            if (elementId) {
                const element = document.getElementById(elementId);
                element?.focus();
            }
            return false;
        }
    }
    switch (validatType) {
        case 'email':
            if (!validator.isLength(fieldValue, { min: 0, max: 70 })) {
                toast.error(`Invalid Email. Field: ${fieldName}.`);
                isvalid = false;
            }
            break;
        case 'name':
            if (!validator.isLength(fieldValue, { min: 0, max: 60 })) {
                toast.error(`Invalid Data. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'namewithspecial':
        if (!validator.isLength(fieldValue, { min: 0, max: 1000 })) {
            toast.error(`Invalid Datsdfdsa. Field: ${fieldName}`);
            isvalid = false;
        }
        break;
        case 'phonenumber':
            if (fieldValue != null && !validator.isLength(fieldValue, { min: 0, max: 15 })) {
                toast.error(`Invalid mobile number. Field: ${fieldName}`)
                isvalid = false;
            }
            break;
        case 'url':
            if (!validator.isLength(fieldValue, { min: 0, max: 100 })) {
                toast.error(`Invalid url. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'linkedinurl':
            if (fieldValue != null && !validator.isLength(fieldValue, { min: 0, max: 256 })) {
                toast.error(`Invalid linkedin Url. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'tshirtsize':
            if (!validator.isLength(fieldValue, { min: 0, max: 6 })) {
                toast.error(`Invalid T-Shirt Size. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'gender':
            if (!validator.isLength(fieldValue, { min: 0, max: 6 })) {
                toast.error(`Invalid Gender. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'ticketType':
            if (!validator.isLength(fieldValue, { min: 0, max: 60 })) {
                toast.error(`Invalid Ticket Type. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'title':
            if (!validator.isLength(fieldValue, { min: 0, max: 60 })) {
                toast.error(`Invalid Data. Field: ${fieldName}, field value ${fieldValue}`);
                isvalid = false;
            }
            break;
        case 'groupType':
            if (!validator.isLength(fieldValue, { min: 0, max: 60 })) {
                toast.error(`Invalid Data. Field: ${fieldName}, field value ${fieldValue}`);
                isvalid = false;
            }
            break;
        case 'venuename':
            if (!validator.isLength(fieldValue, { min: 0, max: 350 })) {
                toast.error(`Invalid Data. Field: ${fieldName}, field value ${fieldValue}`);
                isvalid = false;
            }
            break;
        case 'address':
            if (!validator.isLength(fieldValue, { min: 0, max: 50 })) {
                toast.error(`Invalid Data. Field: ${fieldName}, field value ${fieldValue}`);
                isvalid = false;
            }
            break;
        case 'pincode':
            if (!validator.isLength(fieldValue, { min: 0, max: 6 })) {
                toast.error(`Invalid Data. Field: ${fieldName}, field value ${fieldValue}`);
                isvalid = false;
            }
            break;
        case 'company':
            if (!validator.isLength(fieldValue, { min: 0, max: 150 })) {
                toast.error(`Invalid Data. Field: ${fieldName}, field value ${fieldValue}`);
                isvalid = false;
            }
            break;
        case 'topic':
            if (!validator.isLength(fieldValue, { min: 3, max: 150 })) {
                toast.error(`Invalid Data. Field: ${fieldName}, field value ${fieldValue}`);
                isvalid = false;
            }
            break;

    }

    switch (validatType) {
        case 'email':
            if (!validator.matches(fieldValue, /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                toast.error(`Invalid Email. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'officeemail':
            if (fieldValue != null && !validator.isEmpty(fieldValue) && !validator.matches(fieldValue, /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                toast.error(`Invalid Email. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'name':
            if (!validator.isAlphanumeric(fieldValue, 'en-US', { ignore: ' .-\'' })) {
                toast.error(`Invalid Data. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
            
        case 'phonenumber':
            if (!validator.matches(fieldValue, /^[0-9]{10}$/)) {
                toast.error(`Invalid mobile number. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'trainingid':
            if (!validator.matches(fieldValue, /^[0-9]{1,3}$/)) {
                toast.error(`Invalid mobile number. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'url':
            if (!validator.isURL(fieldValue)) {
                toast.error(`Invalid mobile number. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'linkedinurl':
            if (fieldValue != null && !validator.isEmpty(fieldValue) && (!validator.isURL(fieldValue) || !validator.contains(fieldValue, 'linkedin.com', { ignoreCase: true }))) {
                toast.error(`Invalid linkedin Url. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'tshirtsize':
            if (!validator.matches(fieldValue, 'S|M|L|XL|XXL|XXXL')) {
                toast.error(`Invalid T-Shirt Size. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'gender':
            if (!validator.matches(fieldValue, 'Male|Female|Other')) {
                toast.error(`Invalid Gender. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'ticketType':
            //if(!validator.matches(fieldValue, 'Student Pass|Member Pass|Individual Pass|Corporate Pass'))
            if (validator.matches(fieldValue, 'Ticket Type')) {
                toast.error(`Invalid Ticket Type. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'trainingplan':
            if (!validator.matches(fieldValue, 'NonMember|Member')) {
                toast.error(`Invalid Plan. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'groupType':
            if (!validator.matches(fieldValue, 'BSides Bangalore|W3-CS')) {
                toast.error(`Invalid Group. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'parking':
            if (!validator.matches(fieldValue, 'No|2 Wheeler|4 Wheeler')) {
                toast.error(`Invalid Parking . Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'eventcode':
            if (!validator.matches(fieldValue, /^[a-zA-Z0-9]{4,10}$/)) {
                toast.error(`Invalid Event code. It should be 4-10 Chars and only alphanumeric. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'yesno':
            if (!validator.matches(fieldValue, 'YES|NO|yes|no')) {
                toast.error(`Invalid data. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
            case 'genderall':
                if (!validator.matches(fieldValue, 'ALL|Male|Female|Other')) {
                    toast.error(`Invalid data. Field: ${fieldName}`);
                    isvalid = false;
                }
                break;
        case 'tickettypestatus':
            if (!validator.matches(fieldValue, 'ACTIVE|CLOSED')) {
                toast.error(`Invalid Status. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'speakerstatus':
            if (!validator.matches(fieldValue, 'DRAFT|OPEN|CLOSED|HIDE')) {
                toast.error(`Invalid Status. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'price':
            if (!validator.matches(fieldValue, /^[0-9]{0,8}$/)) {
                toast.error(`Invalid Price. It should be max of 8 digits and No Decimals. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'date':
            if (fieldValue && !validator.matches(fieldValue, /^(([0-9])|([0-2][0-9])|([3][0-1]))\-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\-\d{4}$/)) {
                toast.error(`Invalid Date. ${fieldName} should be in dd-MMM-yyyy eg 01-Jan-2023`);
                isvalid = false;
            }
            break;
        case 'eventstatus':
            if (!validator.matches(fieldValue, 'DRAFT|OPEN|REGISTRATIONSOPEN|REGISTRATIONSCLOSED|HOLD|COMPLETED|CLOSED')) {
                toast.error(`Invalid ${fieldName}.`);
                isvalid = false;
            }
            break;
        case 'pincode':
            if (!validator.matches(fieldValue, /^[0-9]{6}$/)) {
                toast.error(`Invalid ${fieldName}. It should be 6 Digits.`);
                isvalid = false;
            }
            break;
        case 'discount':
            if (!validator.matches(fieldValue, /^(?:[1-9]|[1-9][0-9]|100)$/)) {
                toast.error(`Invalid ${fieldName}. It should be 1-100 only.`);
                isvalid = false;
            }
            break;
        case 'maplink':
            if (!validator.matches(fieldValue, /^https:\/\/www\.google\.com\/maps\/embed\?.*$/)) {
                toast.error(`Invalid ${fieldName}.`);
                isvalid = false;
            }
            break;
        case 'maxusage':
            if (!validator.matches(fieldValue, /^Unlimited|1$/)) {
                toast.error(`Invalid ${fieldName}.`);
                isvalid = false;
            }
            break;
    }

    if (!isvalid && elementId) {
        const element = document.getElementById(elementId);
        element?.focus();
    }
    return isvalid;
}